import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebook, FaInstagram, FaWhatsapp, FaYoutube } from 'react-icons/fa';
import bfooter1 from '../images/blogsimage/bfooter1.jpg';
import bfooter2 from '../images/blogsimage/bfooter2.jpg'
import { useNavigate } from 'react-router-dom';
const Footer = () => {
     const navigate = useNavigate();
  return (
    <>
      <div className='container-fluid bg-black text-white'>
        <div className='container'>
          <style>
            {`
              .container {
                overflow: hidden; /* Prevents horizontal scrolling */
              }

              ul {
                padding-left: 0; /* Remove default padding */
              }

              ul li {
                margin-bottom: 10px; /* Add space between list items */
              }

              h5 {
                margin-bottom: 10px; /* Space below headings */
              }

              /* Remove text decoration from all Link components */
              ul li a {
                text-decoration: none; /* Remove default underline from links */
                color: inherit; /* Make link color inherit from the parent */
              }

              /* Optional: Change link color on hover */
              ul li a:hover {
                text-decoration: underline; /* Underline on hover for better UX */
              }

              .blog-card {
                display: flex;
                flex-direction: row; /* Horizontal layout for larger screens */
                margin: 20px 0;
                border: 1px solid #ccc;
                border-radius: 8px;
                overflow: hidden;
                height: 200px; /* Adjust height for the blog card */
              }

              .blog-image {
                width: 40%; /* Image takes 40% of the width on larger screens */
                height: auto;
              }

              .blog-content {
                padding: 10px; /* Reduced padding */
                display: flex;
                flex-direction: column; /* Content layout */
                justify-content: center; /* Center content vertically */
                height: 100%; /* Ensure it takes the full height */
              }

              .blog-title {
                font-size: 20px; /* Reduced font size */
                margin: 0;
                line-height: 1.2; /* Reduced line height */
              }

              /* Responsive Styles */
              @media (max-width: 768px) {
                .blog-card {
                  flex-direction: column; /* Stack elements for smaller screens */
                  align-items: center; /* Center horizontally */
                }

                .blog-image {
                  width: 100%; /* Full width for mobile */
                }

                .blog-content {
                  text-align: center; /* Center text on mobile */
                }
              }
            `}
          </style>

          {/* First Row */}
          <div className='row d-flex justify-content-between py-4'>
            <div className='col-6'>
              <button className='btn btn-light text-center px-5' onClick={()=>{navigate('/blogs')}}>Get Started</button><br />
              <p className='mx-4 px-3 mt-2'>See Our Plans</p>
            </div>
            <div className='col-6 text-end'>
              <p>9:00 AM to 7:00 PM, Monday - Saturday <br />
              The Nice Office,D-32, 2nd floor, Laxmi Nagar-110092</p>
            </div>
          </div>

          {/* Second Row */}
          <div className='row d-flex justify-content-center border py-4'>
            <div className='col-6 text-center'>
              <p>The Nice Office,D-32, 2nd floor, Laxmi Nagar-110092</p>
            </div>
            <div className='col-6 text-center'>
              <p>info@swingtraderrs.com</p>
            </div>
          </div>

          {/* Links Section */}
          <div className='row d-flex justify-content-between mt-4'>
            {/* Product Links */}
            <div className='col-md-2 col-sm-6 mb-3'>
              <h5>Trading Product</h5>
              <ul className='list-unstyled'>
                <li><Link to="/investment">Investment Solutions</Link></li>
                <li><Link to="/tradingPlatform">Advanced Trading Platforms</Link></li>
                <li><Link to="/educationResource">Trading Education Resources</Link></li>
                 <li><h5>Tech Product</h5></li>
                 <li><Link to="/webDesignAndDevelopment">Website Design & Development</Link></li>
                <li><Link to="/uiUxDesign">AUI/UX Design Services</Link></li>
                <li><Link to="/SEO">SEO & Digital Marketing</Link></li>
              </ul>
            </div>

            {/* Support Links */}
            <div className='col-md-2 col-sm-6 mb-3'>
              <h5>Support</h5>
              <ul className='list-unstyled'>
                
                <li><Link to="/tradingPlatform">Trading Support</Link></li>
                <li><Link to="/contact">Contact Support</Link></li>
                <li><Link to="/technicalCourse">Website Development Help</Link></li>
                <li><Link to="/productAssistance">Product Assistance</Link></li>
                <li><Link to="/technicalAssistance">Technical Assistance</Link></li>
                <li><Link to="/clintServices">Client Services</Link></li>
              </ul>
            </div>

            {/* Solutions Links */}
            <div className='col-md-2 col-sm-6 mb-3'>
              <h5>Solutions</h5>
              <ul className='list-unstyled'>
                <li><Link to="/intermideateCourse">Trading Strategies & Insights</Link></li>
                <li><Link to="/basicCourse">Stock Market Analysis & Trends</Link></li>
                <li><Link to="/AdvanceCourse">Advanced Trading Techniques</Link></li>
                <li><Link to="/webdevelopment">Professional Website Development Solutions</Link></li>
                <li><Link to="/mernstack">Build Your Online Presence with Custom Websites</Link></li>
                <li><Link to="/masterWithPattern">Master Stock Market Trading</Link></li>
                <li><Link to="/webdesign">End-to-End Web Development Services</Link></li>
              </ul>
            </div>

            {/* Visit Us Links */}
            <div className='col-md-2 col-sm-6 mb-3'>
              <h5>Visit Us</h5>
              <ul className='list-unstyled'>
                <li><Link to="/burari">SwingTraderrs Traning Center(Burari)</Link></li>
                <li><Link to="/laxminagar">SwingTraderrs (Laxmi Nagar Branch)</Link></li>
                
              </ul>
            </div>

            {/* Pricing Links */}
            <div className='col-md-2 col-sm-6 mb-3'>
              <h5>Features</h5>
              <ul className='list-unstyled'>
                <li><Link to="/priceandvalue">Affordable Pricing & Value</Link></li>
                <li><Link to="/aonetraning">A-One Teaching & Learning Experience</Link></li>
                <li><Link to="/handsontraning">Hands-On Training & Practical Learning</Link></li>
                <li><Link to="/resourcematerial">Comprehensive Resources & Materials</Link></li>
                <li><Link to="/innovationtechnique">Innovative Techniques & Strategies</Link></li>
                <li><Link to="/experttraning">Expert Trainers & Industry Professionals</Link></li>
              </ul>
            </div>

            {/* Entrepreneur Links */}
            <div className='col-md-2 col-sm-6 mb-3'>
              <h5>Entrepreneur</h5>
              <ul className='list-unstyled'>
                <li><Link to="/onlinemarketer">Online Marketing</Link></li>
                <li><Link to="/marketingmanager">Marketing Manager</Link></li>
                <li><Link to="/joinourteam">Join Our Team </Link></li>
              </ul>
            </div>
          </div>

          {/* Blogs Section */}
          <div className='row'>
            <div className='col-auto'>
              <h2>Blogs</h2>
            </div>
          </div>

          {/* Blog Cards */}
          <div className='blog-card'>
            <img
              src={bfooter1} // Placeholder image URL
              alt='Blog Post'
              className='blog-image'
            />
            <div className='blog-content'>
              <h2 className='blog-title py-2'>
                <Link to="/blogs" className='text-decoration-none'>Trading Mentorship</Link>
              </h2>
              <p>
              Technical analysis involves analyzing historical price movements and trading volume to predict future market trends, helping traders make informed decisions based on patterns and indicators.
              </p>
            </div>
          </div>

          <div className='blog-card'>
            <img
              src={bfooter2} // Placeholder image URL
              alt='Blog Post'
              className='blog-image'
            />
            <div className='blog-content'>
              <h2 className='blog-title py-2'>
                <Link to="/blogs" className='text-decoration-none'>Wealth Creation</Link>
              </h2>
              <p>
              Fundamental analysis focuses on evaluating the intrinsic value of an asset by examining economic, financial, and other qualitative factors, helping traders assess long-term growth potential.
              </p>
            </div>
          </div>

          {/* View More Link and Social Media Links */}
          <h5><Link to="/blogs">View More Post</Link></h5>
          <div className='d-flex justify-content-center gap-5 py-3'>
            <Link to="">
              <FaFacebook size={40} />
            </Link>
            <Link to="https://www.instagram.com/swingtraderrs?igsh=MTJtajNrY2ZkeTkxdw==">
              <FaInstagram size={40} />
            </Link>
            <Link to="https://wa.me/917982950691">
              <FaWhatsapp size={40} />
            </Link>
            <Link to="https://youtube.com/@swingtraderrs?si=7ZFJeVonMz1cJw-o">
              <FaYoutube size={40} />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
